import "angular";
import "angular-resource";
import AccountServiceModule from "../accountServiceModule/AccountServiceModule";
import ClearIbbotsonCacheFactory from "../investmentOptions/ClearIbbotsonCacheFactory";
import InvestmentOverviewFactory from "../investmentOverview/InvestmentOverviewFactory";
import PrimaryPlanTxnAccessService from "../layout/service/primaryPlanTxnAccessService";
import TransactionAccessRetrService from "../layout/service/TransactionAccessRetrService";

import AdviceFactory from "./AdviceFactory";
import AdviceService from "./AdviceService";

const AdviceServiceModule = angular
    .module("AdviceServiceModule", ["ngResource", "AccountServiceModule"])
    .service("adviceService", AdviceService)
    .factory("adviceFactory", AdviceFactory)
    .factory("TransactionAccessRetrService", TransactionAccessRetrService)
    .factory("PrimaryPlanTxnAccessService", PrimaryPlanTxnAccessService)
    .factory("investmentOverviewFactory", InvestmentOverviewFactory)
    .factory("clearIbbotsonCacheFactory", ClearIbbotsonCacheFactory);

export default AdviceServiceModule;
